import { STATE } from "../data/local-storage-constants";
import { getLocalStorage, setLocalStorage } from "./localstorage";

export const loadState = (): any | undefined => {
  try {
    const serializedState = getLocalStorage(STATE);
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: any): void => {
  try {
    const serializedState = JSON.stringify(state);

    setLocalStorage(STATE, serializedState);
  } catch {
    // ignore write errors
  }
};
